import React, { useState, useEffect } from 'react'
import QuestionnaireGroup from './group'
import { Button, Progress } from 'antd'
import { connect } from 'react-redux'
import mapDispatchToProps from '../../dispatch'
import {
  getClientList,
  getClientDetail,
  getQuestionnaire
} from '../../../../models/breadcrumb.model'
import { getSectionModules, getSurveyProgress } from '../../../../api'
import { QuestionniaresContainer } from './style'
import {
  QuestionnaireDoneSmallIcon,
  SendQuestionnaireBtn
} from '../../../../components/icons/questionnaires'
import AnswerProgress from '../../../../components/questionnaire/progress'
// import OldQuestionnaires from '../../../../components/questionnaire/container'
import SendQuestionnaire from './sendQuestionnaireModal'
import SendSuccessModal from './sendSuccessModal'
import { getRole } from '../../../../utils'
import PageLoading from '../../../../components/UI/status/loading'

function QuestionnaireV2(props) {
  const { history, getPerson, setClientBreadcrumb, setClientPageTitle } = props
  const [pageloading, setPageloading] = useState(false)
  const [person, setPerson] = useState(null)
  const [modules, setModules] = useState(null)
  const [sendEmail, setSendEmail] = useState(null)
  const [sendEmailSuccess, setSendEmailSuccess] = useState(false)
  const [answerProgress, setAnswerProgress] = useState(0)

  useEffect(() => {
    const initial = async () => {
      setClientPageTitle('Questionnaire')
      const person = await getPerson()
      setPerson(person)
      setClientBreadcrumb([
        getClientList(),
        getClientDetail(person),
        getQuestionnaire(person.id, true)
      ])
      const modules = await getSectionModules(person.id)
      setModules(modules)
      const progress = await getSurveyProgress(person.id)
      setAnswerProgress(progress.completion_rate)
    }

    initial()
  }, [])

  const refresh = async () => {
    setPageloading(true)
    try {
      const modules = await getSectionModules(person.id)
      setModules(modules)
      const progress = await getSurveyProgress(person.id)
      setAnswerProgress(progress.completion_rate)
    } finally {
      setPageloading(false)
    }
  }

  return (
    <QuestionniaresContainer>
      {getRole() === 'User' && <div className="page-title">Questionnaires</div>}
      {pageloading ? (
        <PageLoading />
      ) : (
        <>
          <AnswerProgress percent={`${answerProgress}`} />
          {modules &&
            modules.map((module) => (
              <div className="module-container" key={module.module}>
                <div className="group-header">
                  {module.module}
                  {module.sections.every((s) => s.multi_answer_version) &&
                    getRole() !== 'User' && (
                      <div>
                        <Button
                          onClick={() =>
                            setSendEmail({
                              title: module.module,
                              originalIds: module.sections.map(
                                (i) => i.original_id
                              )
                            })
                          }
                        >
                          SEND ALL QUESTIONNAIRES
                        </Button>
                      </div>
                    )}
                </div>
                {module.sections.map((section, index) => (
                  <div
                    className={`group ${
                      sectionClickable(section) ? '' : 'no-sessions'
                    }`}
                    key={index}
                    onClick={() => {
                      if (sectionClickable(section)) turnToDetail(section)
                    }}
                    capture={true}
                  >
                    <div>
                      {section.completion_rate >= 100 ? (
                        <QuestionnaireDoneSmallIcon />
                      ) : (
                        <Progress
                          type="circle"
                          percent={section.completion_rate}
                          strokeColor={'#7BAD2D'}
                          trailColor={'#E6E9F2'}
                          width={20}
                          strokeWidth={23}
                          showInfo={false}
                        />
                      )}
                      <span className="group-name">{section.name}</span>
                    </div>
                    {section.multi_answer_version && getRole() !== 'User' && (
                      <SendQuestionnaireBtn
                        onClick={(event) => {
                          event.stopPropagation()
                          setSendEmail({
                            title: section.name,
                            originalIds: [section.original_id]
                          })
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            ))}
        </>
        // <Tabs
        //   defaultActiveKey="1"
        //   items={[
        //     {
        //       label: 'QUESTIONNAIRE',
        //       key: '1',
        //       children: (
        //         <>
        //           <AnswerProgress percent={`${answerProgress}`} />
        //           {modules &&
        //             modules.map((module) => (
        //               <div className="module-container" key={module.module}>
        //                 <div className="group-header">
        //                   {module.module}
        //                   {module.sections.every(
        //                     (s) => s.multi_answer_version
        //                   ) &&
        //                     getRole() !== 'User' && (
        //                       <div>
        //                         <Button
        //                           onClick={() =>
        //                             setSendEmail({
        //                               title: module.module,
        //                               originalIds: module.sections.map(
        //                                 (i) => i.original_id
        //                               )
        //                             })
        //                           }
        //                         >
        //                           SEND ALL QUESTIONNAIRES
        //                         </Button>
        //                       </div>
        //                     )}
        //                 </div>
        //                 {module.sections.map((section, index) => (
        //                   <div
        //                     className={`group ${
        //                       sectionClickable(section) ? '' : 'no-sessions'
        //                     }`}
        //                     key={index}
        //                     onClick={() => {
        //                       if (sectionClickable(section))
        //                         turnToDetail(section)
        //                     }}
        //                     capture={true}
        //                   >
        //                     <div>
        //                       {section.completion_rate >= 100 ? (
        //                         <QuestionnaireDoneSmallIcon />
        //                       ) : (
        //                         <Progress
        //                           type="circle"
        //                           percent={section.completion_rate}
        //                           strokeColor={'#7BAD2D'}
        //                           trailColor={'#E6E9F2'}
        //                           width={20}
        //                           strokeWidth={23}
        //                           showInfo={false}
        //                         />
        //                       )}
        //                       <span className="group-name">{section.name}</span>
        //                     </div>
        //                     {section.multi_answer_version &&
        //                       getRole() !== 'User' && (
        //                         <SendQuestionnaireBtn
        //                           onClick={(event) => {
        //                             event.stopPropagation()
        //                             setSendEmail({
        //                               title: section.name,
        //                               originalIds: [section.original_id]
        //                             })
        //                           }}
        //                         />
        //                       )}
        //                   </div>
        //                 ))}
        //               </div>
        //             ))}
        //         </>
        //       )
        //     },
        //     {
        //       label: 'HISTORY',
        //       key: '2',
        //       children: (
        //         <OldQuestionnaires
        //           person={person}
        //           setEditSection={(activeKey) => {
        //             console.log(activeKey)
        //           }}
        //         />
        //       )
        //     }
        //   ]}
        // />
      )}
      {sendEmail && (
        <SendQuestionnaire
          person={person}
          done={(method) => {
            setSendEmail(null)
            if (method === 'email') {
              setSendEmailSuccess(true)
            } else {
              refresh()
            }
          }}
          onCancel={() => setSendEmail(null)}
          sendEmail={sendEmail}
        />
      )}
      {sendEmailSuccess && (
        <SendSuccessModal
          ok={() => {
            setSendEmailSuccess(false)
            refresh()
          }}
        />
      )}
    </QuestionniaresContainer>
  )

  function turnToDetail(section) {
    const loginRole = getRole()
    if (loginRole === 'User') {
      history.push(
        `/app/questionnaire/group?original_ids=${section.original_id}`
      )
    } else {
      history.push(
        `/client/${person &&
          person.id}/detail/questionnaire/group?original_ids=${
          section.original_id
        }`
      )
    }
  }

  function sectionClickable(section) {
    if (getRole() === 'User') {
      return section.has_sessions
    } else {
      return (
        section.has_sessions ||
        section.original_id === 'pre_medical' ||
        section.original_id === 'lifestyle_goals'
      )
    }
  }
}

export default connect(
  ({ client }) => ({ client }),
  mapDispatchToProps
)(QuestionnaireV2)

export { QuestionnaireGroup }
